import { J2Document } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Backdrop, Box, CircularProgress, IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { printChartData } from 'src/Libs/chart-kit/shared/utils/print-chart-data'

interface Props {
  title: string
  dataFetchTimeStamp: string
  printElementId: string
  installationId?: string
  storageId?: string
}

/**
 * Allows to print a chart (screenshot) based on it's element id
 */
const PowerPriceChartPrint: React.FC<Props> = ({ title, dataFetchTimeStamp, printElementId, installationId, storageId }) => {
  const { t } = useCustomTranslation()

  const [isDownloading, setIsDownloading] = useState<boolean>(false)

  const handleprintChartData = (): void => {
    printChartData(printElementId, title, installationId, storageId, dataFetchTimeStamp, setIsDownloading, t)
  }

  return (
    <>
      <Tooltip title={t('systemDataHandler.chartHeader.print')}>
        <Box component="span">
          <IconButton onClick={handleprintChartData} data-qa={`button-print-chart`} size="large" sx={{ color: 'primary.main' }}>
            <J2Document />
          </IconButton>
        </Box>
      </Tooltip>
      {createPortal(
        <Backdrop open={isDownloading} sx={{ zIndex: 9999 }}>
          <CircularProgress />
        </Backdrop>,
        document.body
      )}
    </>
  )
}

export default PowerPriceChartPrint
